import React from "react";
import { Star, Package, Hash, FileText, Edit, Trash2 } from 'lucide-react';

export const getColumns = ({ onUpdate, onDelete }) => [
  {
    field: "image",
    headerName: "Imagem",
    width: "80px",
    renderCell: ({ row }) => {
      const { value } = row;
      return value ? (
        <img 
          src={value} 
          alt={row.name}
          className="w-10 h-10 rounded-lg object-cover border-2 border-purple-200"
        />
      ) : (
        <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-purple-100 to-pink-100 flex items-center justify-center border-2 border-purple-200">
          <Package className="w-5 h-5 text-purple-500" />
        </div>
      );
    },
    filterable: false,
  },
  {
    field: "name",
    headerName: "Nome",
    flex: 1,
    editable: true,
    renderCell: ({ row }) => {
      return (
        <span className="font-medium text-gray-900">
          {row.name || 'Sem nome'}
        </span>
      );
    },
  },
  {
    field: "slug",
    headerName: "Slug Principal",
    flex: 1,
    editable: true,
    renderCell: ({ row }) => {
      return (
        <span className="font-mono text-sm text-gray-600">
          {row.slug || 'Sem slug'}
        </span>
      );
    },
  },
  {
    field: "description",
    headerName: "Descrição",
    flex: 1,
    editable: true,
    sortable: false,
    renderCell: ({ row }) => {
      return (
        <span className="text-sm line-clamp-2 max-w-xs text-gray-700">
          {row.description || 'Sem descrição'}
        </span>
      );
    },
  },
  {
    field: "is_popular",
    headerName: <Star className="w-4 h-4" />,
    description: "É Popular?",
    type: "boolean",
    editable: true,
    sortable: false,
    width: "100px",
    renderCell: ({ row }) => {
      return (
        <button
          onClick={() => onUpdate(row.id, 'is_popular', !row.is_popular)}
          className={`p-2 rounded-full transition-colors ${
            row.is_popular
              ? 'bg-yellow-100 text-yellow-600 hover:bg-yellow-200'
              : 'bg-gray-100 text-gray-400 hover:bg-gray-200'
          }`}
          title={row.is_popular ? 'Popular' : 'Não popular'}
        >
          <Star className={`h-4 w-4 ${row.is_popular ? 'fill-current' : ''}`} />
        </button>
      );
    },
  },
  {
    field: "weight",
    headerName: <Hash className="w-4 h-4" />,
    description: "Peso",
    type: "number",
    editable: true,
    sortable: false,
    width: "100px",
    renderCell: ({ row }) => {
      return (
        <span className="font-semibold text-center block text-gray-900">
          {row.weight || '0'}
        </span>
      );
    },
  },
];